var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ri:map-pin-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.8337 16.1421L13.4171 20.577C12.6354 21.3619 11.3646 21.3619 10.5829 20.577L6.16634 16.1421C5.01256 14.9835 4.22684 13.5074 3.90852 11.9004C3.5902 10.2934 3.75358 8.62774 4.37801 7.11399C5.00243 5.60025 6.05986 4.30643 7.41656 3.39614C8.77326 2.48586 10.3683 2 12 2C13.6317 2 15.2267 2.48586 16.5834 3.39614C17.9401 4.30643 18.9976 5.60025 19.622 7.11399C20.2464 8.62774 20.4098 10.2934 20.0915 11.9004C19.7732 13.5074 18.9874 14.9835 17.8337 16.1421ZM12 13.9661C12.9725 13.9661 13.9051 13.5782 14.5927 12.8877C15.2804 12.1972 15.6667 11.2607 15.6667 10.2842C15.6667 9.3077 15.2804 8.37119 14.5927 7.6807C13.9051 6.99021 12.9725 6.6023 12 6.6023C11.0275 6.6023 10.0949 6.99021 9.40728 7.6807C8.71964 8.37119 8.33333 9.3077 8.33333 10.2842C8.33333 11.2607 8.71964 12.1972 9.40728 12.8877C10.0949 13.5782 11.0275 13.9661 12 13.9661ZM12 12.1251C11.5138 12.1251 11.0475 11.9312 10.7036 11.5859C10.3598 11.2407 10.1667 10.7724 10.1667 10.2842C10.1667 9.79595 10.3598 9.3277 10.7036 8.98245C11.0475 8.63721 11.5138 8.44325 12 8.44325C12.4862 8.44325 12.9525 8.63721 13.2964 8.98245C13.6402 9.3277 13.8333 9.79595 13.8333 10.2842C13.8333 10.7724 13.6402 11.2407 13.2964 11.5859C12.9525 11.9312 12.4862 12.1251 12 12.1251Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.6ed1772e52d9d08a9fb46b737a646aa2.svg";
export { ForwardRef as ReactComponent };